import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import Layout from "@/components/templates/Layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const storedTheme = localStorage.getItem("theme");
const defaultTheme = "light";

let theme = defaultTheme;

try {
  const parsedTheme = storedTheme ? JSON.parse(storedTheme) : null;
  
  if (parsedTheme && typeof parsedTheme === "object" && parsedTheme.state && typeof parsedTheme.state.theme === "string") {
    theme = parsedTheme.state.theme;
  } else {
    throw new Error("Invalid theme format");
  }
} catch (e) {
  theme = defaultTheme;
  localStorage.setItem("theme", JSON.stringify({ state: { theme: defaultTheme } }));
}


const createApp = () =>
  createInertiaApp({
    resolve: (name) => {
      const pages = import.meta.glob(
        ["./pages/**/*.tsx", "!./pages/**/*.{test,spec}.tsx"],
        { eager: true }
      );

      return pages[`./pages/${name}.tsx`];
    },
    setup({ el, App, props }) {
      const { initialPage } = props;
      const pageName = props.initialPage.component;

      const isLayoutNeeded = !["pages/Login", "pages/ResetPassword", "pages/ConfirmUser", "pages/RateTicket"].includes(pageName);
      createRoot(el).render(
        <>
          {isLayoutNeeded ? (
            <Layout activeNotice={initialPage.props.activeNotice}>
              <App {...props} />
            </Layout>
          ) : (
            <App {...props} />
          )}
          <ToastContainer theme={theme} position="bottom-right" />
        </>
      );
    },
    progress: {
      delay: 250,
      color: "#29d",
      includeCSS: true,
      showSpinner: false,
    },
  });

export default createApp;
